var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 76,
    viewBox: "0 0 1320 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    clipPath: "url(#clip0_1_3583)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_3583)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 17.4437C255.122 17.4437 256 16.5662 256 15.4837C256 14.4012 255.122 13.5237 254.04 13.5237C252.958 13.5237 252.08 14.4012 252.08 15.4837C252.08 16.5662 252.958 17.4437 254.04 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 35.4437C255.122 35.4437 256 34.5662 256 33.4837C256 32.4012 255.122 31.5237 254.04 31.5237C252.958 31.5237 252.08 32.4012 252.08 33.4837C252.08 34.5662 252.958 35.4437 254.04 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 53.4537C255.122 53.4537 256 52.5762 256 51.4937C256 50.4112 255.122 49.5337 254.04 49.5337C252.958 49.5337 252.08 50.4112 252.08 51.4937C252.08 52.5762 252.958 53.4537 254.04 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M254.04 71.4537C255.122 71.4537 256 70.5762 256 69.4937C256 68.4112 255.122 67.5337 254.04 67.5337C252.958 67.5337 252.08 68.4112 252.08 69.4937C252.08 70.5762 252.958 71.4537 254.04 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 17.4437C237.112 17.4437 237.99 16.5662 237.99 15.4837C237.99 14.4012 237.112 13.5237 236.03 13.5237C234.948 13.5237 234.07 14.4012 234.07 15.4837C234.07 16.5662 234.948 17.4437 236.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 35.4437C237.112 35.4437 237.99 34.5662 237.99 33.4837C237.99 32.4012 237.112 31.5237 236.03 31.5237C234.948 31.5237 234.07 32.4012 234.07 33.4837C234.07 34.5662 234.948 35.4437 236.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 53.4537C237.112 53.4537 237.99 52.5762 237.99 51.4937C237.99 50.4112 237.112 49.5337 236.03 49.5337C234.948 49.5337 234.07 50.4112 234.07 51.4937C234.07 52.5762 234.948 53.4537 236.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M236.03 71.4537C237.112 71.4537 237.99 70.5762 237.99 69.4937C237.99 68.4112 237.112 67.5337 236.03 67.5337C234.948 67.5337 234.07 68.4112 234.07 69.4937C234.07 70.5762 234.948 71.4537 236.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 17.4437C219.112 17.4437 219.99 16.5662 219.99 15.4837C219.99 14.4012 219.112 13.5237 218.03 13.5237C216.948 13.5237 216.07 14.4012 216.07 15.4837C216.07 16.5662 216.948 17.4437 218.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 35.4437C219.112 35.4437 219.99 34.5662 219.99 33.4837C219.99 32.4012 219.112 31.5237 218.03 31.5237C216.948 31.5237 216.07 32.4012 216.07 33.4837C216.07 34.5662 216.948 35.4437 218.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 53.4537C219.112 53.4537 219.99 52.5762 219.99 51.4937C219.99 50.4112 219.112 49.5337 218.03 49.5337C216.948 49.5337 216.07 50.4112 216.07 51.4937C216.07 52.5762 216.948 53.4537 218.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M218.03 71.4537C219.112 71.4537 219.99 70.5762 219.99 69.4937C219.99 68.4112 219.112 67.5337 218.03 67.5337C216.948 67.5337 216.07 68.4112 216.07 69.4937C216.07 70.5762 216.948 71.4537 218.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M200.02 17.4437C201.102 17.4437 201.98 16.5662 201.98 15.4837C201.98 14.4012 201.102 13.5237 200.02 13.5237C198.938 13.5237 198.06 14.4012 198.06 15.4837C198.06 16.5662 198.938 17.4437 200.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M200.02 35.4437C201.102 35.4437 201.98 34.5662 201.98 33.4837C201.98 32.4012 201.102 31.5237 200.02 31.5237C198.938 31.5237 198.06 32.4012 198.06 33.4837C198.06 34.5662 198.938 35.4437 200.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M200.02 53.4537C201.102 53.4537 201.98 52.5762 201.98 51.4937C201.98 50.4112 201.102 49.5337 200.02 49.5337C198.938 49.5337 198.06 50.4112 198.06 51.4937C198.06 52.5762 198.938 53.4537 200.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.02 71.4537C201.102 71.4537 201.98 70.5762 201.98 69.4937C201.98 68.4112 201.102 67.5337 200.02 67.5337C198.938 67.5337 198.06 68.4112 198.06 69.4937C198.06 70.5762 198.938 71.4537 200.02 71.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 17.4437C183.102 17.4437 183.98 16.5662 183.98 15.4837C183.98 14.4012 183.102 13.5237 182.02 13.5237C180.938 13.5237 180.06 14.4012 180.06 15.4837C180.06 16.5662 180.938 17.4437 182.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 35.4437C183.102 35.4437 183.98 34.5662 183.98 33.4837C183.98 32.4012 183.102 31.5237 182.02 31.5237C180.938 31.5237 180.06 32.4012 180.06 33.4837C180.06 34.5662 180.938 35.4437 182.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 53.4537C183.102 53.4537 183.98 52.5762 183.98 51.4937C183.98 50.4112 183.102 49.5337 182.02 49.5337C180.938 49.5337 180.06 50.4112 180.06 51.4937C180.06 52.5762 180.938 53.4537 182.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M182.02 71.4537C183.102 71.4537 183.98 70.5762 183.98 69.4937C183.98 68.4112 183.102 67.5337 182.02 67.5337C180.938 67.5337 180.06 68.4112 180.06 69.4937C180.06 70.5762 180.938 71.4537 182.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 17.4437C165.092 17.4437 165.97 16.5662 165.97 15.4837C165.97 14.4012 165.092 13.5237 164.01 13.5237C162.928 13.5237 162.05 14.4012 162.05 15.4837C162.05 16.5662 162.928 17.4437 164.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 35.4437C165.092 35.4437 165.97 34.5662 165.97 33.4837C165.97 32.4012 165.092 31.5237 164.01 31.5237C162.928 31.5237 162.05 32.4012 162.05 33.4837C162.05 34.5662 162.928 35.4437 164.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 53.4537C165.092 53.4537 165.97 52.5762 165.97 51.4937C165.97 50.4112 165.092 49.5337 164.01 49.5337C162.928 49.5337 162.05 50.4112 162.05 51.4937C162.05 52.5762 162.928 53.4537 164.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M164.01 71.4537C165.092 71.4537 165.97 70.5762 165.97 69.4937C165.97 68.4112 165.092 67.5337 164.01 67.5337C162.928 67.5337 162.05 68.4112 162.05 69.4937C162.05 70.5762 162.928 71.4537 164.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 17.4437C147.092 17.4437 147.97 16.5662 147.97 15.4837C147.97 14.4012 147.092 13.5237 146.01 13.5237C144.928 13.5237 144.05 14.4012 144.05 15.4837C144.05 16.5662 144.928 17.4437 146.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 35.4437C147.092 35.4437 147.97 34.5662 147.97 33.4837C147.97 32.4012 147.092 31.5237 146.01 31.5237C144.928 31.5237 144.05 32.4012 144.05 33.4837C144.05 34.5662 144.928 35.4437 146.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 53.4537C147.092 53.4537 147.97 52.5762 147.97 51.4937C147.97 50.4112 147.092 49.5337 146.01 49.5337C144.928 49.5337 144.05 50.4112 144.05 51.4937C144.05 52.5762 144.928 53.4537 146.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M146.01 71.4537C147.092 71.4537 147.97 70.5762 147.97 69.4937C147.97 68.4112 147.092 67.5337 146.01 67.5337C144.928 67.5337 144.05 68.4112 144.05 69.4937C144.05 70.5762 144.928 71.4537 146.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 17.4437C129.082 17.4437 129.96 16.5662 129.96 15.4837C129.96 14.4012 129.082 13.5237 128 13.5237C126.917 13.5237 126.04 14.4012 126.04 15.4837C126.04 16.5662 126.917 17.4437 128 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 35.4437C129.082 35.4437 129.96 34.5662 129.96 33.4837C129.96 32.4012 129.082 31.5237 128 31.5237C126.917 31.5237 126.04 32.4012 126.04 33.4837C126.04 34.5662 126.917 35.4437 128 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 53.4537C129.082 53.4537 129.96 52.5762 129.96 51.4937C129.96 50.4112 129.082 49.5337 128 49.5337C126.917 49.5337 126.04 50.4112 126.04 51.4937C126.04 52.5762 126.917 53.4537 128 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M128 71.4537C129.082 71.4537 129.96 70.5762 129.96 69.4937C129.96 68.4112 129.082 67.5337 128 67.5337C126.917 67.5337 126.04 68.4112 126.04 69.4937C126.04 70.5762 126.917 71.4537 128 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 17.4437C111.073 17.4437 111.95 16.5662 111.95 15.4837C111.95 14.4012 111.073 13.5237 109.99 13.5237C108.908 13.5237 108.03 14.4012 108.03 15.4837C108.03 16.5662 108.908 17.4437 109.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 35.4437C111.073 35.4437 111.95 34.5662 111.95 33.4837C111.95 32.4012 111.073 31.5237 109.99 31.5237C108.908 31.5237 108.03 32.4012 108.03 33.4837C108.03 34.5662 108.908 35.4437 109.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 53.4537C111.073 53.4537 111.95 52.5762 111.95 51.4937C111.95 50.4112 111.073 49.5337 109.99 49.5337C108.908 49.5337 108.03 50.4112 108.03 51.4937C108.03 52.5762 108.908 53.4537 109.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M109.99 71.4537C111.073 71.4537 111.95 70.5762 111.95 69.4937C111.95 68.4112 111.073 67.5337 109.99 67.5337C108.908 67.5337 108.03 68.4112 108.03 69.4937C108.03 70.5762 108.908 71.4537 109.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 17.4437C93.0725 17.4437 93.95 16.5662 93.95 15.4837C93.95 14.4012 93.0725 13.5237 91.99 13.5237C90.9076 13.5237 90.03 14.4012 90.03 15.4837C90.03 16.5662 90.9076 17.4437 91.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 35.4437C93.0725 35.4437 93.95 34.5662 93.95 33.4837C93.95 32.4012 93.0725 31.5237 91.99 31.5237C90.9076 31.5237 90.03 32.4012 90.03 33.4837C90.03 34.5662 90.9076 35.4437 91.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 53.4537C93.0725 53.4537 93.95 52.5762 93.95 51.4937C93.95 50.4112 93.0725 49.5337 91.99 49.5337C90.9076 49.5337 90.03 50.4112 90.03 51.4937C90.03 52.5762 90.9076 53.4537 91.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M91.99 71.4537C93.0725 71.4537 93.95 70.5762 93.95 69.4937C93.95 68.4112 93.0725 67.5337 91.99 67.5337C90.9076 67.5337 90.03 68.4112 90.03 69.4937C90.03 70.5762 90.9076 71.4537 91.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 17.4437C75.0625 17.4437 75.94 16.5662 75.94 15.4837C75.94 14.4012 75.0625 13.5237 73.98 13.5237C72.8975 13.5237 72.02 14.4012 72.02 15.4837C72.02 16.5662 72.8975 17.4437 73.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 35.4437C75.0625 35.4437 75.94 34.5662 75.94 33.4837C75.94 32.4012 75.0625 31.5237 73.98 31.5237C72.8975 31.5237 72.02 32.4012 72.02 33.4837C72.02 34.5662 72.8975 35.4437 73.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 53.4537C75.0625 53.4537 75.94 52.5762 75.94 51.4937C75.94 50.4112 75.0625 49.5337 73.98 49.5337C72.8975 49.5337 72.02 50.4112 72.02 51.4937C72.02 52.5762 72.8975 53.4537 73.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M73.98 71.4537C75.0625 71.4537 75.94 70.5762 75.94 69.4937C75.94 68.4112 75.0625 67.5337 73.98 67.5337C72.8975 67.5337 72.02 68.4112 72.02 69.4937C72.02 70.5762 72.8975 71.4537 73.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 17.4437C57.0625 17.4437 57.94 16.5662 57.94 15.4837C57.94 14.4012 57.0625 13.5237 55.98 13.5237C54.8975 13.5237 54.02 14.4012 54.02 15.4837C54.02 16.5662 54.8975 17.4437 55.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 35.4437C57.0625 35.4437 57.94 34.5662 57.94 33.4837C57.94 32.4012 57.0625 31.5237 55.98 31.5237C54.8975 31.5237 54.02 32.4012 54.02 33.4837C54.02 34.5662 54.8975 35.4437 55.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 53.4537C57.0625 53.4537 57.94 52.5762 57.94 51.4937C57.94 50.4112 57.0625 49.5337 55.98 49.5337C54.8975 49.5337 54.02 50.4112 54.02 51.4937C54.02 52.5762 54.8975 53.4537 55.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M55.98 71.4537C57.0625 71.4537 57.94 70.5762 57.94 69.4937C57.94 68.4112 57.0625 67.5337 55.98 67.5337C54.8975 67.5337 54.02 68.4112 54.02 69.4937C54.02 70.5762 54.8975 71.4537 55.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.97 17.4437C39.0525 17.4437 39.93 16.5662 39.93 15.4837C39.93 14.4012 39.0525 13.5237 37.97 13.5237C36.8875 13.5237 36.01 14.4012 36.01 15.4837C36.01 16.5662 36.8875 17.4437 37.97 17.4437Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M37.97 35.4437C39.0525 35.4437 39.93 34.5662 39.93 33.4837C39.93 32.4012 39.0525 31.5237 37.97 31.5237C36.8875 31.5237 36.01 32.4012 36.01 33.4837C36.01 34.5662 36.8875 35.4437 37.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M37.97 53.4537C39.0525 53.4537 39.93 52.5762 39.93 51.4937C39.93 50.4112 39.0525 49.5337 37.97 49.5337C36.8875 49.5337 36.01 50.4112 36.01 51.4937C36.01 52.5762 36.8875 53.4537 37.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M37.97 71.4537C39.0525 71.4537 39.93 70.5762 39.93 69.4937C39.93 68.4112 39.0525 67.5337 37.97 67.5337C36.8875 67.5337 36.01 68.4112 36.01 69.4937C36.01 70.5762 36.8875 71.4537 37.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 17.4437C21.0525 17.4437 21.93 16.5662 21.93 15.4837C21.93 14.4012 21.0525 13.5237 19.97 13.5237C18.8875 13.5237 18.01 14.4012 18.01 15.4837C18.01 16.5662 18.8875 17.4437 19.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 35.4437C21.0525 35.4437 21.93 34.5662 21.93 33.4837C21.93 32.4012 21.0525 31.5237 19.97 31.5237C18.8875 31.5237 18.01 32.4012 18.01 33.4837C18.01 34.5662 18.8875 35.4437 19.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 53.4537C21.0525 53.4537 21.93 52.5762 21.93 51.4937C21.93 50.4112 21.0525 49.5337 19.97 49.5337C18.8875 49.5337 18.01 50.4112 18.01 51.4937C18.01 52.5762 18.8875 53.4537 19.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.97 71.4537C21.0525 71.4537 21.93 70.5762 21.93 69.4937C21.93 68.4112 21.0525 67.5337 19.97 67.5337C18.8875 67.5337 18.01 68.4112 18.01 69.4937C18.01 70.5762 18.8875 71.4537 19.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 17.4437C3.04248 17.4437 3.92 16.5662 3.92 15.4837C3.92 14.4012 3.04248 13.5237 1.96 13.5237C0.877522 13.5237 0 14.4012 0 15.4837C0 16.5662 0.877522 17.4437 1.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 35.4437C3.04248 35.4437 3.92 34.5662 3.92 33.4837C3.92 32.4012 3.04248 31.5237 1.96 31.5237C0.877522 31.5237 0 32.4012 0 33.4837C0 34.5662 0.877522 35.4437 1.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 53.4537C3.04248 53.4537 3.92 52.5762 3.92 51.4937C3.92 50.4112 3.04248 49.5337 1.96 49.5337C0.877522 49.5337 0 50.4112 0 51.4937C0 52.5762 0.877522 53.4537 1.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1.96 71.4537C3.04248 71.4537 3.92 70.5762 3.92 69.4937C3.92 68.4112 3.04248 67.5337 1.96 67.5337C0.877522 67.5337 0 68.4112 0 69.4937C0 70.5762 0.877522 71.4537 1.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 17.4437C507.122 17.4437 508 16.5662 508 15.4837C508 14.4012 507.122 13.5237 506.04 13.5237C504.958 13.5237 504.08 14.4012 504.08 15.4837C504.08 16.5662 504.958 17.4437 506.04 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 35.4437C507.122 35.4437 508 34.5662 508 33.4837C508 32.4012 507.122 31.5237 506.04 31.5237C504.958 31.5237 504.08 32.4012 504.08 33.4837C504.08 34.5662 504.958 35.4437 506.04 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 53.4537C507.122 53.4537 508 52.5762 508 51.4937C508 50.4112 507.122 49.5337 506.04 49.5337C504.958 49.5337 504.08 50.4112 504.08 51.4937C504.08 52.5762 504.958 53.4537 506.04 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M506.04 71.4537C507.122 71.4537 508 70.5762 508 69.4937C508 68.4112 507.122 67.5337 506.04 67.5337C504.958 67.5337 504.08 68.4112 504.08 69.4937C504.08 70.5762 504.958 71.4537 506.04 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 17.4437C489.112 17.4437 489.99 16.5662 489.99 15.4837C489.99 14.4012 489.112 13.5237 488.03 13.5237C486.948 13.5237 486.07 14.4012 486.07 15.4837C486.07 16.5662 486.948 17.4437 488.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 35.4437C489.112 35.4437 489.99 34.5662 489.99 33.4837C489.99 32.4012 489.112 31.5237 488.03 31.5237C486.948 31.5237 486.07 32.4012 486.07 33.4837C486.07 34.5662 486.948 35.4437 488.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 53.4537C489.112 53.4537 489.99 52.5762 489.99 51.4937C489.99 50.4112 489.112 49.5337 488.03 49.5337C486.948 49.5337 486.07 50.4112 486.07 51.4937C486.07 52.5762 486.948 53.4537 488.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M488.03 71.4537C489.112 71.4537 489.99 70.5762 489.99 69.4937C489.99 68.4112 489.112 67.5337 488.03 67.5337C486.948 67.5337 486.07 68.4112 486.07 69.4937C486.07 70.5762 486.948 71.4537 488.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 17.4437C471.112 17.4437 471.99 16.5662 471.99 15.4837C471.99 14.4012 471.112 13.5237 470.03 13.5237C468.948 13.5237 468.07 14.4012 468.07 15.4837C468.07 16.5662 468.948 17.4437 470.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 35.4437C471.112 35.4437 471.99 34.5662 471.99 33.4837C471.99 32.4012 471.112 31.5237 470.03 31.5237C468.948 31.5237 468.07 32.4012 468.07 33.4837C468.07 34.5662 468.948 35.4437 470.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 53.4537C471.112 53.4537 471.99 52.5762 471.99 51.4937C471.99 50.4112 471.112 49.5337 470.03 49.5337C468.948 49.5337 468.07 50.4112 468.07 51.4937C468.07 52.5762 468.948 53.4537 470.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M470.03 71.4537C471.112 71.4537 471.99 70.5762 471.99 69.4937C471.99 68.4112 471.112 67.5337 470.03 67.5337C468.948 67.5337 468.07 68.4112 468.07 69.4937C468.07 70.5762 468.948 71.4537 470.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M452.02 17.4437C453.102 17.4437 453.98 16.5662 453.98 15.4837C453.98 14.4012 453.102 13.5237 452.02 13.5237C450.938 13.5237 450.06 14.4012 450.06 15.4837C450.06 16.5662 450.938 17.4437 452.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M452.02 35.4437C453.102 35.4437 453.98 34.5662 453.98 33.4837C453.98 32.4012 453.102 31.5237 452.02 31.5237C450.938 31.5237 450.06 32.4012 450.06 33.4837C450.06 34.5662 450.938 35.4437 452.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M452.02 53.4537C453.102 53.4537 453.98 52.5762 453.98 51.4937C453.98 50.4112 453.102 49.5337 452.02 49.5337C450.938 49.5337 450.06 50.4112 450.06 51.4937C450.06 52.5762 450.938 53.4537 452.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.02 71.4537C453.102 71.4537 453.98 70.5762 453.98 69.4937C453.98 68.4112 453.102 67.5337 452.02 67.5337C450.938 67.5337 450.06 68.4112 450.06 69.4937C450.06 70.5762 450.938 71.4537 452.02 71.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 17.4437C435.102 17.4437 435.98 16.5662 435.98 15.4837C435.98 14.4012 435.102 13.5237 434.02 13.5237C432.938 13.5237 432.06 14.4012 432.06 15.4837C432.06 16.5662 432.938 17.4437 434.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 35.4437C435.102 35.4437 435.98 34.5662 435.98 33.4837C435.98 32.4012 435.102 31.5237 434.02 31.5237C432.938 31.5237 432.06 32.4012 432.06 33.4837C432.06 34.5662 432.938 35.4437 434.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 53.4537C435.102 53.4537 435.98 52.5762 435.98 51.4937C435.98 50.4112 435.102 49.5337 434.02 49.5337C432.938 49.5337 432.06 50.4112 432.06 51.4937C432.06 52.5762 432.938 53.4537 434.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M434.02 71.4537C435.102 71.4537 435.98 70.5762 435.98 69.4937C435.98 68.4112 435.102 67.5337 434.02 67.5337C432.938 67.5337 432.06 68.4112 432.06 69.4937C432.06 70.5762 432.938 71.4537 434.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 17.4437C417.092 17.4437 417.97 16.5662 417.97 15.4837C417.97 14.4012 417.092 13.5237 416.01 13.5237C414.928 13.5237 414.05 14.4012 414.05 15.4837C414.05 16.5662 414.928 17.4437 416.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 35.4437C417.092 35.4437 417.97 34.5662 417.97 33.4837C417.97 32.4012 417.092 31.5237 416.01 31.5237C414.928 31.5237 414.05 32.4012 414.05 33.4837C414.05 34.5662 414.928 35.4437 416.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 53.4537C417.092 53.4537 417.97 52.5762 417.97 51.4937C417.97 50.4112 417.092 49.5337 416.01 49.5337C414.928 49.5337 414.05 50.4112 414.05 51.4937C414.05 52.5762 414.928 53.4537 416.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M416.01 71.4537C417.092 71.4537 417.97 70.5762 417.97 69.4937C417.97 68.4112 417.092 67.5337 416.01 67.5337C414.928 67.5337 414.05 68.4112 414.05 69.4937C414.05 70.5762 414.928 71.4537 416.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 17.4437C399.092 17.4437 399.97 16.5662 399.97 15.4837C399.97 14.4012 399.092 13.5237 398.01 13.5237C396.928 13.5237 396.05 14.4012 396.05 15.4837C396.05 16.5662 396.928 17.4437 398.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 35.4437C399.092 35.4437 399.97 34.5662 399.97 33.4837C399.97 32.4012 399.092 31.5237 398.01 31.5237C396.928 31.5237 396.05 32.4012 396.05 33.4837C396.05 34.5662 396.928 35.4437 398.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 53.4537C399.092 53.4537 399.97 52.5762 399.97 51.4937C399.97 50.4112 399.092 49.5337 398.01 49.5337C396.928 49.5337 396.05 50.4112 396.05 51.4937C396.05 52.5762 396.928 53.4537 398.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M398.01 71.4537C399.092 71.4537 399.97 70.5762 399.97 69.4937C399.97 68.4112 399.092 67.5337 398.01 67.5337C396.928 67.5337 396.05 68.4112 396.05 69.4937C396.05 70.5762 396.928 71.4537 398.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 17.4437C381.082 17.4437 381.96 16.5662 381.96 15.4837C381.96 14.4012 381.082 13.5237 380 13.5237C378.918 13.5237 378.04 14.4012 378.04 15.4837C378.04 16.5662 378.918 17.4437 380 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 35.4437C381.082 35.4437 381.96 34.5662 381.96 33.4837C381.96 32.4012 381.082 31.5237 380 31.5237C378.918 31.5237 378.04 32.4012 378.04 33.4837C378.04 34.5662 378.918 35.4437 380 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 53.4537C381.082 53.4537 381.96 52.5762 381.96 51.4937C381.96 50.4112 381.082 49.5337 380 49.5337C378.918 49.5337 378.04 50.4112 378.04 51.4937C378.04 52.5762 378.918 53.4537 380 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M380 71.4537C381.082 71.4537 381.96 70.5762 381.96 69.4937C381.96 68.4112 381.082 67.5337 380 67.5337C378.918 67.5337 378.04 68.4112 378.04 69.4937C378.04 70.5762 378.918 71.4537 380 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 17.4437C363.072 17.4437 363.95 16.5662 363.95 15.4837C363.95 14.4012 363.072 13.5237 361.99 13.5237C360.908 13.5237 360.03 14.4012 360.03 15.4837C360.03 16.5662 360.908 17.4437 361.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 35.4437C363.072 35.4437 363.95 34.5662 363.95 33.4837C363.95 32.4012 363.072 31.5237 361.99 31.5237C360.908 31.5237 360.03 32.4012 360.03 33.4837C360.03 34.5662 360.908 35.4437 361.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 53.4537C363.072 53.4537 363.95 52.5762 363.95 51.4937C363.95 50.4112 363.072 49.5337 361.99 49.5337C360.908 49.5337 360.03 50.4112 360.03 51.4937C360.03 52.5762 360.908 53.4537 361.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M361.99 71.4537C363.072 71.4537 363.95 70.5762 363.95 69.4937C363.95 68.4112 363.072 67.5337 361.99 67.5337C360.908 67.5337 360.03 68.4112 360.03 69.4937C360.03 70.5762 360.908 71.4537 361.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 17.4437C345.072 17.4437 345.95 16.5662 345.95 15.4837C345.95 14.4012 345.072 13.5237 343.99 13.5237C342.908 13.5237 342.03 14.4012 342.03 15.4837C342.03 16.5662 342.908 17.4437 343.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 35.4437C345.072 35.4437 345.95 34.5662 345.95 33.4837C345.95 32.4012 345.072 31.5237 343.99 31.5237C342.908 31.5237 342.03 32.4012 342.03 33.4837C342.03 34.5662 342.908 35.4437 343.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 53.4537C345.072 53.4537 345.95 52.5762 345.95 51.4937C345.95 50.4112 345.072 49.5337 343.99 49.5337C342.908 49.5337 342.03 50.4112 342.03 51.4937C342.03 52.5762 342.908 53.4537 343.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M343.99 71.4537C345.072 71.4537 345.95 70.5762 345.95 69.4937C345.95 68.4112 345.072 67.5337 343.99 67.5337C342.908 67.5337 342.03 68.4112 342.03 69.4937C342.03 70.5762 342.908 71.4537 343.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 17.4437C327.062 17.4437 327.94 16.5662 327.94 15.4837C327.94 14.4012 327.062 13.5237 325.98 13.5237C324.898 13.5237 324.02 14.4012 324.02 15.4837C324.02 16.5662 324.898 17.4437 325.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 35.4437C327.062 35.4437 327.94 34.5662 327.94 33.4837C327.94 32.4012 327.062 31.5237 325.98 31.5237C324.898 31.5237 324.02 32.4012 324.02 33.4837C324.02 34.5662 324.898 35.4437 325.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 53.4537C327.062 53.4537 327.94 52.5762 327.94 51.4937C327.94 50.4112 327.062 49.5337 325.98 49.5337C324.898 49.5337 324.02 50.4112 324.02 51.4937C324.02 52.5762 324.898 53.4537 325.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M325.98 71.4537C327.062 71.4537 327.94 70.5762 327.94 69.4937C327.94 68.4112 327.062 67.5337 325.98 67.5337C324.898 67.5337 324.02 68.4112 324.02 69.4937C324.02 70.5762 324.898 71.4537 325.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 17.4437C309.062 17.4437 309.94 16.5662 309.94 15.4837C309.94 14.4012 309.062 13.5237 307.98 13.5237C306.898 13.5237 306.02 14.4012 306.02 15.4837C306.02 16.5662 306.898 17.4437 307.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 35.4437C309.062 35.4437 309.94 34.5662 309.94 33.4837C309.94 32.4012 309.062 31.5237 307.98 31.5237C306.898 31.5237 306.02 32.4012 306.02 33.4837C306.02 34.5662 306.898 35.4437 307.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 53.4537C309.062 53.4537 309.94 52.5762 309.94 51.4937C309.94 50.4112 309.062 49.5337 307.98 49.5337C306.898 49.5337 306.02 50.4112 306.02 51.4937C306.02 52.5762 306.898 53.4537 307.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M307.98 71.4537C309.062 71.4537 309.94 70.5762 309.94 69.4937C309.94 68.4112 309.062 67.5337 307.98 67.5337C306.898 67.5337 306.02 68.4112 306.02 69.4937C306.02 70.5762 306.898 71.4537 307.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.97 17.4437C291.052 17.4437 291.93 16.5662 291.93 15.4837C291.93 14.4012 291.052 13.5237 289.97 13.5237C288.888 13.5237 288.01 14.4012 288.01 15.4837C288.01 16.5662 288.888 17.4437 289.97 17.4437Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M289.97 35.4437C291.052 35.4437 291.93 34.5662 291.93 33.4837C291.93 32.4012 291.052 31.5237 289.97 31.5237C288.888 31.5237 288.01 32.4012 288.01 33.4837C288.01 34.5662 288.888 35.4437 289.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M289.97 53.4537C291.052 53.4537 291.93 52.5762 291.93 51.4937C291.93 50.4112 291.052 49.5337 289.97 49.5337C288.888 49.5337 288.01 50.4112 288.01 51.4937C288.01 52.5762 288.888 53.4537 289.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M289.97 71.4537C291.052 71.4537 291.93 70.5762 291.93 69.4937C291.93 68.4112 291.052 67.5337 289.97 67.5337C288.888 67.5337 288.01 68.4112 288.01 69.4937C288.01 70.5762 288.888 71.4537 289.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 17.4437C273.052 17.4437 273.93 16.5662 273.93 15.4837C273.93 14.4012 273.052 13.5237 271.97 13.5237C270.888 13.5237 270.01 14.4012 270.01 15.4837C270.01 16.5662 270.888 17.4437 271.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 35.4437C273.052 35.4437 273.93 34.5662 273.93 33.4837C273.93 32.4012 273.052 31.5237 271.97 31.5237C270.888 31.5237 270.01 32.4012 270.01 33.4837C270.01 34.5662 270.888 35.4437 271.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 53.4537C273.052 53.4537 273.93 52.5762 273.93 51.4937C273.93 50.4112 273.052 49.5337 271.97 49.5337C270.888 49.5337 270.01 50.4112 270.01 51.4937C270.01 52.5762 270.888 53.4537 271.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M271.97 71.4537C273.052 71.4537 273.93 70.5762 273.93 69.4937C273.93 68.4112 273.052 67.5337 271.97 67.5337C270.888 67.5337 270.01 68.4112 270.01 69.4937C270.01 70.5762 270.888 71.4537 271.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 17.4437C255.042 17.4437 255.92 16.5662 255.92 15.4837C255.92 14.4012 255.042 13.5237 253.96 13.5237C252.878 13.5237 252 14.4012 252 15.4837C252 16.5662 252.878 17.4437 253.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 35.4437C255.042 35.4437 255.92 34.5662 255.92 33.4837C255.92 32.4012 255.042 31.5237 253.96 31.5237C252.878 31.5237 252 32.4012 252 33.4837C252 34.5662 252.878 35.4437 253.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 53.4537C255.042 53.4537 255.92 52.5762 255.92 51.4937C255.92 50.4112 255.042 49.5337 253.96 49.5337C252.878 49.5337 252 50.4112 252 51.4937C252 52.5762 252.878 53.4537 253.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M253.96 71.4537C255.042 71.4537 255.92 70.5762 255.92 69.4937C255.92 68.4112 255.042 67.5337 253.96 67.5337C252.878 67.5337 252 68.4112 252 69.4937C252 70.5762 252.878 71.4537 253.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 17.4437C759.122 17.4437 760 16.5662 760 15.4837C760 14.4012 759.122 13.5237 758.04 13.5237C756.957 13.5237 756.08 14.4012 756.08 15.4837C756.08 16.5662 756.957 17.4437 758.04 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 35.4437C759.122 35.4437 760 34.5662 760 33.4837C760 32.4012 759.122 31.5237 758.04 31.5237C756.957 31.5237 756.08 32.4012 756.08 33.4837C756.08 34.5662 756.957 35.4437 758.04 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 53.4537C759.122 53.4537 760 52.5762 760 51.4937C760 50.4112 759.122 49.5337 758.04 49.5337C756.957 49.5337 756.08 50.4112 756.08 51.4937C756.08 52.5762 756.957 53.4537 758.04 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M758.04 71.4537C759.122 71.4537 760 70.5762 760 69.4937C760 68.4112 759.122 67.5337 758.04 67.5337C756.957 67.5337 756.08 68.4112 756.08 69.4937C756.08 70.5762 756.957 71.4537 758.04 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 17.4437C741.113 17.4437 741.99 16.5662 741.99 15.4837C741.99 14.4012 741.113 13.5237 740.03 13.5237C738.948 13.5237 738.07 14.4012 738.07 15.4837C738.07 16.5662 738.948 17.4437 740.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 35.4437C741.113 35.4437 741.99 34.5662 741.99 33.4837C741.99 32.4012 741.113 31.5237 740.03 31.5237C738.948 31.5237 738.07 32.4012 738.07 33.4837C738.07 34.5662 738.948 35.4437 740.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 53.4537C741.113 53.4537 741.99 52.5762 741.99 51.4937C741.99 50.4112 741.113 49.5337 740.03 49.5337C738.948 49.5337 738.07 50.4112 738.07 51.4937C738.07 52.5762 738.948 53.4537 740.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M740.03 71.4537C741.113 71.4537 741.99 70.5762 741.99 69.4937C741.99 68.4112 741.113 67.5337 740.03 67.5337C738.948 67.5337 738.07 68.4112 738.07 69.4937C738.07 70.5762 738.948 71.4537 740.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 17.4437C723.113 17.4437 723.99 16.5662 723.99 15.4837C723.99 14.4012 723.113 13.5237 722.03 13.5237C720.948 13.5237 720.07 14.4012 720.07 15.4837C720.07 16.5662 720.948 17.4437 722.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 35.4437C723.113 35.4437 723.99 34.5662 723.99 33.4837C723.99 32.4012 723.113 31.5237 722.03 31.5237C720.948 31.5237 720.07 32.4012 720.07 33.4837C720.07 34.5662 720.948 35.4437 722.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 53.4537C723.113 53.4537 723.99 52.5762 723.99 51.4937C723.99 50.4112 723.113 49.5337 722.03 49.5337C720.948 49.5337 720.07 50.4112 720.07 51.4937C720.07 52.5762 720.948 53.4537 722.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M722.03 71.4537C723.113 71.4537 723.99 70.5762 723.99 69.4937C723.99 68.4112 723.113 67.5337 722.03 67.5337C720.948 67.5337 720.07 68.4112 720.07 69.4937C720.07 70.5762 720.948 71.4537 722.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M704.02 17.4437C705.102 17.4437 705.98 16.5662 705.98 15.4837C705.98 14.4012 705.102 13.5237 704.02 13.5237C702.938 13.5237 702.06 14.4012 702.06 15.4837C702.06 16.5662 702.938 17.4437 704.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M704.02 35.4437C705.102 35.4437 705.98 34.5662 705.98 33.4837C705.98 32.4012 705.102 31.5237 704.02 31.5237C702.938 31.5237 702.06 32.4012 702.06 33.4837C702.06 34.5662 702.938 35.4437 704.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M704.02 53.4537C705.102 53.4537 705.98 52.5762 705.98 51.4937C705.98 50.4112 705.102 49.5337 704.02 49.5337C702.938 49.5337 702.06 50.4112 702.06 51.4937C702.06 52.5762 702.938 53.4537 704.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.02 71.4537C705.102 71.4537 705.98 70.5762 705.98 69.4937C705.98 68.4112 705.102 67.5337 704.02 67.5337C702.938 67.5337 702.06 68.4112 702.06 69.4937C702.06 70.5762 702.938 71.4537 704.02 71.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 17.4437C687.102 17.4437 687.98 16.5662 687.98 15.4837C687.98 14.4012 687.102 13.5237 686.02 13.5237C684.938 13.5237 684.06 14.4012 684.06 15.4837C684.06 16.5662 684.938 17.4437 686.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 35.4437C687.102 35.4437 687.98 34.5662 687.98 33.4837C687.98 32.4012 687.102 31.5237 686.02 31.5237C684.938 31.5237 684.06 32.4012 684.06 33.4837C684.06 34.5662 684.938 35.4437 686.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 53.4537C687.102 53.4537 687.98 52.5762 687.98 51.4937C687.98 50.4112 687.102 49.5337 686.02 49.5337C684.938 49.5337 684.06 50.4112 684.06 51.4937C684.06 52.5762 684.938 53.4537 686.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M686.02 71.4537C687.102 71.4537 687.98 70.5762 687.98 69.4937C687.98 68.4112 687.102 67.5337 686.02 67.5337C684.938 67.5337 684.06 68.4112 684.06 69.4937C684.06 70.5762 684.938 71.4537 686.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 17.4437C669.092 17.4437 669.97 16.5662 669.97 15.4837C669.97 14.4012 669.092 13.5237 668.01 13.5237C666.928 13.5237 666.05 14.4012 666.05 15.4837C666.05 16.5662 666.928 17.4437 668.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 35.4437C669.092 35.4437 669.97 34.5662 669.97 33.4837C669.97 32.4012 669.092 31.5237 668.01 31.5237C666.928 31.5237 666.05 32.4012 666.05 33.4837C666.05 34.5662 666.928 35.4437 668.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 53.4537C669.092 53.4537 669.97 52.5762 669.97 51.4937C669.97 50.4112 669.092 49.5337 668.01 49.5337C666.928 49.5337 666.05 50.4112 666.05 51.4937C666.05 52.5762 666.928 53.4537 668.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M668.01 71.4537C669.092 71.4537 669.97 70.5762 669.97 69.4937C669.97 68.4112 669.092 67.5337 668.01 67.5337C666.928 67.5337 666.05 68.4112 666.05 69.4937C666.05 70.5762 666.928 71.4537 668.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 17.4437C651.092 17.4437 651.97 16.5662 651.97 15.4837C651.97 14.4012 651.092 13.5237 650.01 13.5237C648.928 13.5237 648.05 14.4012 648.05 15.4837C648.05 16.5662 648.928 17.4437 650.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 35.4437C651.092 35.4437 651.97 34.5662 651.97 33.4837C651.97 32.4012 651.092 31.5237 650.01 31.5237C648.928 31.5237 648.05 32.4012 648.05 33.4837C648.05 34.5662 648.928 35.4437 650.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 53.4537C651.092 53.4537 651.97 52.5762 651.97 51.4937C651.97 50.4112 651.092 49.5337 650.01 49.5337C648.928 49.5337 648.05 50.4112 648.05 51.4937C648.05 52.5762 648.928 53.4537 650.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M650.01 71.4537C651.092 71.4537 651.97 70.5762 651.97 69.4937C651.97 68.4112 651.092 67.5337 650.01 67.5337C648.928 67.5337 648.05 68.4112 648.05 69.4937C648.05 70.5762 648.928 71.4537 650.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 17.4437C633.082 17.4437 633.96 16.5662 633.96 15.4837C633.96 14.4012 633.082 13.5237 632 13.5237C630.918 13.5237 630.04 14.4012 630.04 15.4837C630.04 16.5662 630.918 17.4437 632 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 35.4437C633.082 35.4437 633.96 34.5662 633.96 33.4837C633.96 32.4012 633.082 31.5237 632 31.5237C630.918 31.5237 630.04 32.4012 630.04 33.4837C630.04 34.5662 630.918 35.4437 632 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 53.4537C633.082 53.4537 633.96 52.5762 633.96 51.4937C633.96 50.4112 633.082 49.5337 632 49.5337C630.918 49.5337 630.04 50.4112 630.04 51.4937C630.04 52.5762 630.918 53.4537 632 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M632 71.4537C633.082 71.4537 633.96 70.5762 633.96 69.4937C633.96 68.4112 633.082 67.5337 632 67.5337C630.918 67.5337 630.04 68.4112 630.04 69.4937C630.04 70.5762 630.918 71.4537 632 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 17.4437C615.072 17.4437 615.95 16.5662 615.95 15.4837C615.95 14.4012 615.072 13.5237 613.99 13.5237C612.908 13.5237 612.03 14.4012 612.03 15.4837C612.03 16.5662 612.908 17.4437 613.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 35.4437C615.072 35.4437 615.95 34.5662 615.95 33.4837C615.95 32.4012 615.072 31.5237 613.99 31.5237C612.908 31.5237 612.03 32.4012 612.03 33.4837C612.03 34.5662 612.908 35.4437 613.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 53.4537C615.072 53.4537 615.95 52.5762 615.95 51.4937C615.95 50.4112 615.072 49.5337 613.99 49.5337C612.908 49.5337 612.03 50.4112 612.03 51.4937C612.03 52.5762 612.908 53.4537 613.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M613.99 71.4537C615.072 71.4537 615.95 70.5762 615.95 69.4937C615.95 68.4112 615.072 67.5337 613.99 67.5337C612.908 67.5337 612.03 68.4112 612.03 69.4937C612.03 70.5762 612.908 71.4537 613.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 17.4437C597.072 17.4437 597.95 16.5662 597.95 15.4837C597.95 14.4012 597.072 13.5237 595.99 13.5237C594.908 13.5237 594.03 14.4012 594.03 15.4837C594.03 16.5662 594.908 17.4437 595.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 35.4437C597.072 35.4437 597.95 34.5662 597.95 33.4837C597.95 32.4012 597.072 31.5237 595.99 31.5237C594.908 31.5237 594.03 32.4012 594.03 33.4837C594.03 34.5662 594.908 35.4437 595.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 53.4537C597.072 53.4537 597.95 52.5762 597.95 51.4937C597.95 50.4112 597.072 49.5337 595.99 49.5337C594.908 49.5337 594.03 50.4112 594.03 51.4937C594.03 52.5762 594.908 53.4537 595.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M595.99 71.4537C597.072 71.4537 597.95 70.5762 597.95 69.4937C597.95 68.4112 597.072 67.5337 595.99 67.5337C594.908 67.5337 594.03 68.4112 594.03 69.4937C594.03 70.5762 594.908 71.4537 595.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 17.4437C579.062 17.4437 579.94 16.5662 579.94 15.4837C579.94 14.4012 579.062 13.5237 577.98 13.5237C576.898 13.5237 576.02 14.4012 576.02 15.4837C576.02 16.5662 576.898 17.4437 577.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 35.4437C579.062 35.4437 579.94 34.5662 579.94 33.4837C579.94 32.4012 579.062 31.5237 577.98 31.5237C576.898 31.5237 576.02 32.4012 576.02 33.4837C576.02 34.5662 576.898 35.4437 577.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 53.4537C579.062 53.4537 579.94 52.5762 579.94 51.4937C579.94 50.4112 579.062 49.5337 577.98 49.5337C576.898 49.5337 576.02 50.4112 576.02 51.4937C576.02 52.5762 576.898 53.4537 577.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M577.98 71.4537C579.062 71.4537 579.94 70.5762 579.94 69.4937C579.94 68.4112 579.062 67.5337 577.98 67.5337C576.898 67.5337 576.02 68.4112 576.02 69.4937C576.02 70.5762 576.898 71.4537 577.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 17.4437C561.062 17.4437 561.94 16.5662 561.94 15.4837C561.94 14.4012 561.062 13.5237 559.98 13.5237C558.898 13.5237 558.02 14.4012 558.02 15.4837C558.02 16.5662 558.898 17.4437 559.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 35.4437C561.062 35.4437 561.94 34.5662 561.94 33.4837C561.94 32.4012 561.062 31.5237 559.98 31.5237C558.898 31.5237 558.02 32.4012 558.02 33.4837C558.02 34.5662 558.898 35.4437 559.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 53.4537C561.062 53.4537 561.94 52.5762 561.94 51.4937C561.94 50.4112 561.062 49.5337 559.98 49.5337C558.898 49.5337 558.02 50.4112 558.02 51.4937C558.02 52.5762 558.898 53.4537 559.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M559.98 71.4537C561.062 71.4537 561.94 70.5762 561.94 69.4937C561.94 68.4112 561.062 67.5337 559.98 67.5337C558.898 67.5337 558.02 68.4112 558.02 69.4937C558.02 70.5762 558.898 71.4537 559.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.97 17.4437C543.052 17.4437 543.93 16.5662 543.93 15.4837C543.93 14.4012 543.052 13.5237 541.97 13.5237C540.887 13.5237 540.01 14.4012 540.01 15.4837C540.01 16.5662 540.887 17.4437 541.97 17.4437Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M541.97 35.4437C543.052 35.4437 543.93 34.5662 543.93 33.4837C543.93 32.4012 543.052 31.5237 541.97 31.5237C540.887 31.5237 540.01 32.4012 540.01 33.4837C540.01 34.5662 540.887 35.4437 541.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M541.97 53.4537C543.052 53.4537 543.93 52.5762 543.93 51.4937C543.93 50.4112 543.052 49.5337 541.97 49.5337C540.887 49.5337 540.01 50.4112 540.01 51.4937C540.01 52.5762 540.887 53.4537 541.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M541.97 71.4537C543.052 71.4537 543.93 70.5762 543.93 69.4937C543.93 68.4112 543.052 67.5337 541.97 67.5337C540.887 67.5337 540.01 68.4112 540.01 69.4937C540.01 70.5762 540.887 71.4537 541.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 17.4437C525.052 17.4437 525.93 16.5662 525.93 15.4837C525.93 14.4012 525.052 13.5237 523.97 13.5237C522.887 13.5237 522.01 14.4012 522.01 15.4837C522.01 16.5662 522.887 17.4437 523.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 35.4437C525.052 35.4437 525.93 34.5662 525.93 33.4837C525.93 32.4012 525.052 31.5237 523.97 31.5237C522.887 31.5237 522.01 32.4012 522.01 33.4837C522.01 34.5662 522.887 35.4437 523.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 53.4537C525.052 53.4537 525.93 52.5762 525.93 51.4937C525.93 50.4112 525.052 49.5337 523.97 49.5337C522.887 49.5337 522.01 50.4112 522.01 51.4937C522.01 52.5762 522.887 53.4537 523.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M523.97 71.4537C525.052 71.4537 525.93 70.5762 525.93 69.4937C525.93 68.4112 525.052 67.5337 523.97 67.5337C522.887 67.5337 522.01 68.4112 522.01 69.4937C522.01 70.5762 522.887 71.4537 523.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 17.4437C507.042 17.4437 507.92 16.5662 507.92 15.4837C507.92 14.4012 507.042 13.5237 505.96 13.5237C504.878 13.5237 504 14.4012 504 15.4837C504 16.5662 504.878 17.4437 505.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 35.4437C507.042 35.4437 507.92 34.5662 507.92 33.4837C507.92 32.4012 507.042 31.5237 505.96 31.5237C504.878 31.5237 504 32.4012 504 33.4837C504 34.5662 504.878 35.4437 505.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 53.4537C507.042 53.4537 507.92 52.5762 507.92 51.4937C507.92 50.4112 507.042 49.5337 505.96 49.5337C504.878 49.5337 504 50.4112 504 51.4937C504 52.5762 504.878 53.4537 505.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M505.96 71.4537C507.042 71.4537 507.92 70.5762 507.92 69.4937C507.92 68.4112 507.042 67.5337 505.96 67.5337C504.878 67.5337 504 68.4112 504 69.4937C504 70.5762 504.878 71.4537 505.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 71.4537C1263.04 71.4537 1263.92 70.5762 1263.92 69.4937C1263.92 68.4112 1263.04 67.5337 1261.96 67.5337C1260.88 67.5337 1260 68.4112 1260 69.4937C1260 70.5762 1260.88 71.4537 1261.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 53.4537C1263.04 53.4537 1263.92 52.5762 1263.92 51.4937C1263.92 50.4112 1263.04 49.5337 1261.96 49.5337C1260.88 49.5337 1260 50.4112 1260 51.4937C1260 52.5762 1260.88 53.4537 1261.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 35.4437C1263.04 35.4437 1263.92 34.5662 1263.92 33.4837C1263.92 32.4012 1263.04 31.5237 1261.96 31.5237C1260.88 31.5237 1260 32.4012 1260 33.4837C1260 34.5662 1260.88 35.4437 1261.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1261.96 17.4437C1263.04 17.4437 1263.92 16.5662 1263.92 15.4837C1263.92 14.4012 1263.04 13.5237 1261.96 13.5237C1260.88 13.5237 1260 14.4012 1260 15.4837C1260 16.5662 1260.88 17.4437 1261.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1279.97 71.4537C1281.05 71.4537 1281.93 70.5762 1281.93 69.4937C1281.93 68.4112 1281.05 67.5337 1279.97 67.5337C1278.89 67.5337 1278.01 68.4112 1278.01 69.4937C1278.01 70.5762 1278.89 71.4537 1279.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.97 53.4537C1281.05 53.4537 1281.93 52.5762 1281.93 51.4937C1281.93 50.4112 1281.05 49.5337 1279.97 49.5337C1278.89 49.5337 1278.01 50.4112 1278.01 51.4937C1278.01 52.5762 1278.89 53.4537 1279.97 53.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1279.97 35.4437C1281.05 35.4437 1281.93 34.5662 1281.93 33.4837C1281.93 32.4012 1281.05 31.5237 1279.97 31.5237C1278.89 31.5237 1278.01 32.4012 1278.01 33.4837C1278.01 34.5662 1278.89 35.4437 1279.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1279.97 17.4437C1281.05 17.4437 1281.93 16.5662 1281.93 15.4837C1281.93 14.4012 1281.05 13.5237 1279.97 13.5237C1278.89 13.5237 1278.01 14.4012 1278.01 15.4837C1278.01 16.5662 1278.89 17.4437 1279.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 71.4537C1299.05 71.4537 1299.93 70.5762 1299.93 69.4937C1299.93 68.4112 1299.05 67.5337 1297.97 67.5337C1296.89 67.5337 1296.01 68.4112 1296.01 69.4937C1296.01 70.5762 1296.89 71.4537 1297.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 53.4537C1299.05 53.4537 1299.93 52.5762 1299.93 51.4937C1299.93 50.4112 1299.05 49.5337 1297.97 49.5337C1296.89 49.5337 1296.01 50.4112 1296.01 51.4937C1296.01 52.5762 1296.89 53.4537 1297.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 35.4437C1299.05 35.4437 1299.93 34.5662 1299.93 33.4837C1299.93 32.4012 1299.05 31.5237 1297.97 31.5237C1296.89 31.5237 1296.01 32.4012 1296.01 33.4837C1296.01 34.5662 1296.89 35.4437 1297.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1297.97 17.4437C1299.05 17.4437 1299.93 16.5662 1299.93 15.4837C1299.93 14.4012 1299.05 13.5237 1297.97 13.5237C1296.89 13.5237 1296.01 14.4012 1296.01 15.4837C1296.01 16.5662 1296.89 17.4437 1297.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 71.4537C1317.06 71.4537 1317.94 70.5762 1317.94 69.4937C1317.94 68.4112 1317.06 67.5337 1315.98 67.5337C1314.9 67.5337 1314.02 68.4112 1314.02 69.4937C1314.02 70.5762 1314.9 71.4537 1315.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 53.4537C1317.06 53.4537 1317.94 52.5762 1317.94 51.4937C1317.94 50.4112 1317.06 49.5337 1315.98 49.5337C1314.9 49.5337 1314.02 50.4112 1314.02 51.4937C1314.02 52.5762 1314.9 53.4537 1315.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 35.4437C1317.06 35.4437 1317.94 34.5662 1317.94 33.4837C1317.94 32.4012 1317.06 31.5237 1315.98 31.5237C1314.9 31.5237 1314.02 32.4012 1314.02 33.4837C1314.02 34.5662 1314.9 35.4437 1315.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1315.98 17.4437C1317.06 17.4437 1317.94 16.5662 1317.94 15.4837C1317.94 14.4012 1317.06 13.5237 1315.98 13.5237C1314.9 13.5237 1314.02 14.4012 1314.02 15.4837C1314.02 16.5662 1314.9 17.4437 1315.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 71.4537C1011.04 71.4537 1011.92 70.5762 1011.92 69.4937C1011.92 68.4112 1011.04 67.5337 1009.96 67.5337C1008.88 67.5337 1008 68.4112 1008 69.4937C1008 70.5762 1008.88 71.4537 1009.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 53.4537C1011.04 53.4537 1011.92 52.5762 1011.92 51.4937C1011.92 50.4112 1011.04 49.5337 1009.96 49.5337C1008.88 49.5337 1008 50.4112 1008 51.4937C1008 52.5762 1008.88 53.4537 1009.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 35.4437C1011.04 35.4437 1011.92 34.5662 1011.92 33.4837C1011.92 32.4012 1011.04 31.5237 1009.96 31.5237C1008.88 31.5237 1008 32.4012 1008 33.4837C1008 34.5662 1008.88 35.4437 1009.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1009.96 17.4437C1011.04 17.4437 1011.92 16.5662 1011.92 15.4837C1011.92 14.4012 1011.04 13.5237 1009.96 13.5237C1008.88 13.5237 1008 14.4012 1008 15.4837C1008 16.5662 1008.88 17.4437 1009.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1027.97 71.4537C1029.05 71.4537 1029.93 70.5762 1029.93 69.4937C1029.93 68.4112 1029.05 67.5337 1027.97 67.5337C1026.89 67.5337 1026.01 68.4112 1026.01 69.4937C1026.01 70.5762 1026.89 71.4537 1027.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.97 53.4537C1029.05 53.4537 1029.93 52.5762 1029.93 51.4937C1029.93 50.4112 1029.05 49.5337 1027.97 49.5337C1026.89 49.5337 1026.01 50.4112 1026.01 51.4937C1026.01 52.5762 1026.89 53.4537 1027.97 53.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1027.97 35.4437C1029.05 35.4437 1029.93 34.5662 1029.93 33.4837C1029.93 32.4012 1029.05 31.5237 1027.97 31.5237C1026.89 31.5237 1026.01 32.4012 1026.01 33.4837C1026.01 34.5662 1026.89 35.4437 1027.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1027.97 17.4437C1029.05 17.4437 1029.93 16.5662 1029.93 15.4837C1029.93 14.4012 1029.05 13.5237 1027.97 13.5237C1026.89 13.5237 1026.01 14.4012 1026.01 15.4837C1026.01 16.5662 1026.89 17.4437 1027.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 71.4537C1047.05 71.4537 1047.93 70.5762 1047.93 69.4937C1047.93 68.4112 1047.05 67.5337 1045.97 67.5337C1044.89 67.5337 1044.01 68.4112 1044.01 69.4937C1044.01 70.5762 1044.89 71.4537 1045.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 53.4537C1047.05 53.4537 1047.93 52.5762 1047.93 51.4937C1047.93 50.4112 1047.05 49.5337 1045.97 49.5337C1044.89 49.5337 1044.01 50.4112 1044.01 51.4937C1044.01 52.5762 1044.89 53.4537 1045.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 35.4437C1047.05 35.4437 1047.93 34.5662 1047.93 33.4837C1047.93 32.4012 1047.05 31.5237 1045.97 31.5237C1044.89 31.5237 1044.01 32.4012 1044.01 33.4837C1044.01 34.5662 1044.89 35.4437 1045.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1045.97 17.4437C1047.05 17.4437 1047.93 16.5662 1047.93 15.4837C1047.93 14.4012 1047.05 13.5237 1045.97 13.5237C1044.89 13.5237 1044.01 14.4012 1044.01 15.4837C1044.01 16.5662 1044.89 17.4437 1045.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 71.4537C1065.06 71.4537 1065.94 70.5762 1065.94 69.4937C1065.94 68.4112 1065.06 67.5337 1063.98 67.5337C1062.9 67.5337 1062.02 68.4112 1062.02 69.4937C1062.02 70.5762 1062.9 71.4537 1063.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 53.4537C1065.06 53.4537 1065.94 52.5762 1065.94 51.4937C1065.94 50.4112 1065.06 49.5337 1063.98 49.5337C1062.9 49.5337 1062.02 50.4112 1062.02 51.4937C1062.02 52.5762 1062.9 53.4537 1063.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 35.4437C1065.06 35.4437 1065.94 34.5662 1065.94 33.4837C1065.94 32.4012 1065.06 31.5237 1063.98 31.5237C1062.9 31.5237 1062.02 32.4012 1062.02 33.4837C1062.02 34.5662 1062.9 35.4437 1063.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1063.98 17.4437C1065.06 17.4437 1065.94 16.5662 1065.94 15.4837C1065.94 14.4012 1065.06 13.5237 1063.98 13.5237C1062.9 13.5237 1062.02 14.4012 1062.02 15.4837C1062.02 16.5662 1062.9 17.4437 1063.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 71.4537C1083.06 71.4537 1083.94 70.5762 1083.94 69.4937C1083.94 68.4112 1083.06 67.5337 1081.98 67.5337C1080.9 67.5337 1080.02 68.4112 1080.02 69.4937C1080.02 70.5762 1080.9 71.4537 1081.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 53.4537C1083.06 53.4537 1083.94 52.5762 1083.94 51.4937C1083.94 50.4112 1083.06 49.5337 1081.98 49.5337C1080.9 49.5337 1080.02 50.4112 1080.02 51.4937C1080.02 52.5762 1080.9 53.4537 1081.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 35.4437C1083.06 35.4437 1083.94 34.5662 1083.94 33.4837C1083.94 32.4012 1083.06 31.5237 1081.98 31.5237C1080.9 31.5237 1080.02 32.4012 1080.02 33.4837C1080.02 34.5662 1080.9 35.4437 1081.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1081.98 17.4437C1083.06 17.4437 1083.94 16.5662 1083.94 15.4837C1083.94 14.4012 1083.06 13.5237 1081.98 13.5237C1080.9 13.5237 1080.02 14.4012 1080.02 15.4837C1080.02 16.5662 1080.9 17.4437 1081.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 71.4537C1101.07 71.4537 1101.95 70.5762 1101.95 69.4937C1101.95 68.4112 1101.07 67.5337 1099.99 67.5337C1098.91 67.5337 1098.03 68.4112 1098.03 69.4937C1098.03 70.5762 1098.91 71.4537 1099.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 53.4537C1101.07 53.4537 1101.95 52.5762 1101.95 51.4937C1101.95 50.4112 1101.07 49.5337 1099.99 49.5337C1098.91 49.5337 1098.03 50.4112 1098.03 51.4937C1098.03 52.5762 1098.91 53.4537 1099.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 35.4437C1101.07 35.4437 1101.95 34.5662 1101.95 33.4837C1101.95 32.4012 1101.07 31.5237 1099.99 31.5237C1098.91 31.5237 1098.03 32.4012 1098.03 33.4837C1098.03 34.5662 1098.91 35.4437 1099.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1099.99 17.4437C1101.07 17.4437 1101.95 16.5662 1101.95 15.4837C1101.95 14.4012 1101.07 13.5237 1099.99 13.5237C1098.91 13.5237 1098.03 14.4012 1098.03 15.4837C1098.03 16.5662 1098.91 17.4437 1099.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 71.4537C1119.07 71.4537 1119.95 70.5762 1119.95 69.4937C1119.95 68.4112 1119.07 67.5337 1117.99 67.5337C1116.91 67.5337 1116.03 68.4112 1116.03 69.4937C1116.03 70.5762 1116.91 71.4537 1117.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 53.4537C1119.07 53.4537 1119.95 52.5762 1119.95 51.4937C1119.95 50.4112 1119.07 49.5337 1117.99 49.5337C1116.91 49.5337 1116.03 50.4112 1116.03 51.4937C1116.03 52.5762 1116.91 53.4537 1117.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 35.4437C1119.07 35.4437 1119.95 34.5662 1119.95 33.4837C1119.95 32.4012 1119.07 31.5237 1117.99 31.5237C1116.91 31.5237 1116.03 32.4012 1116.03 33.4837C1116.03 34.5662 1116.91 35.4437 1117.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1117.99 17.4437C1119.07 17.4437 1119.95 16.5662 1119.95 15.4837C1119.95 14.4012 1119.07 13.5237 1117.99 13.5237C1116.91 13.5237 1116.03 14.4012 1116.03 15.4837C1116.03 16.5662 1116.91 17.4437 1117.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 71.4537C1137.08 71.4537 1137.96 70.5762 1137.96 69.4937C1137.96 68.4112 1137.08 67.5337 1136 67.5337C1134.92 67.5337 1134.04 68.4112 1134.04 69.4937C1134.04 70.5762 1134.92 71.4537 1136 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 53.4537C1137.08 53.4537 1137.96 52.5762 1137.96 51.4937C1137.96 50.4112 1137.08 49.5337 1136 49.5337C1134.92 49.5337 1134.04 50.4112 1134.04 51.4937C1134.04 52.5762 1134.92 53.4537 1136 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 35.4437C1137.08 35.4437 1137.96 34.5662 1137.96 33.4837C1137.96 32.4012 1137.08 31.5237 1136 31.5237C1134.92 31.5237 1134.04 32.4012 1134.04 33.4837C1134.04 34.5662 1134.92 35.4437 1136 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1136 17.4437C1137.08 17.4437 1137.96 16.5662 1137.96 15.4837C1137.96 14.4012 1137.08 13.5237 1136 13.5237C1134.92 13.5237 1134.04 14.4012 1134.04 15.4837C1134.04 16.5662 1134.92 17.4437 1136 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 71.4537C1155.09 71.4537 1155.97 70.5762 1155.97 69.4937C1155.97 68.4112 1155.09 67.5337 1154.01 67.5337C1152.93 67.5337 1152.05 68.4112 1152.05 69.4937C1152.05 70.5762 1152.93 71.4537 1154.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 53.4537C1155.09 53.4537 1155.97 52.5762 1155.97 51.4937C1155.97 50.4112 1155.09 49.5337 1154.01 49.5337C1152.93 49.5337 1152.05 50.4112 1152.05 51.4937C1152.05 52.5762 1152.93 53.4537 1154.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 35.4437C1155.09 35.4437 1155.97 34.5662 1155.97 33.4837C1155.97 32.4012 1155.09 31.5237 1154.01 31.5237C1152.93 31.5237 1152.05 32.4012 1152.05 33.4837C1152.05 34.5662 1152.93 35.4437 1154.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1154.01 17.4437C1155.09 17.4437 1155.97 16.5662 1155.97 15.4837C1155.97 14.4012 1155.09 13.5237 1154.01 13.5237C1152.93 13.5237 1152.05 14.4012 1152.05 15.4837C1152.05 16.5662 1152.93 17.4437 1154.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 71.4537C1173.09 71.4537 1173.97 70.5762 1173.97 69.4937C1173.97 68.4112 1173.09 67.5337 1172.01 67.5337C1170.93 67.5337 1170.05 68.4112 1170.05 69.4937C1170.05 70.5762 1170.93 71.4537 1172.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 53.4537C1173.09 53.4537 1173.97 52.5762 1173.97 51.4937C1173.97 50.4112 1173.09 49.5337 1172.01 49.5337C1170.93 49.5337 1170.05 50.4112 1170.05 51.4937C1170.05 52.5762 1170.93 53.4537 1172.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 35.4437C1173.09 35.4437 1173.97 34.5662 1173.97 33.4837C1173.97 32.4012 1173.09 31.5237 1172.01 31.5237C1170.93 31.5237 1170.05 32.4012 1170.05 33.4837C1170.05 34.5662 1170.93 35.4437 1172.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1172.01 17.4437C1173.09 17.4437 1173.97 16.5662 1173.97 15.4837C1173.97 14.4012 1173.09 13.5237 1172.01 13.5237C1170.93 13.5237 1170.05 14.4012 1170.05 15.4837C1170.05 16.5662 1170.93 17.4437 1172.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 71.4537C1191.1 71.4537 1191.98 70.5762 1191.98 69.4937C1191.98 68.4112 1191.1 67.5337 1190.02 67.5337C1188.94 67.5337 1188.06 68.4112 1188.06 69.4937C1188.06 70.5762 1188.94 71.4537 1190.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 53.4537C1191.1 53.4537 1191.98 52.5762 1191.98 51.4937C1191.98 50.4112 1191.1 49.5337 1190.02 49.5337C1188.94 49.5337 1188.06 50.4112 1188.06 51.4937C1188.06 52.5762 1188.94 53.4537 1190.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 35.4437C1191.1 35.4437 1191.98 34.5662 1191.98 33.4837C1191.98 32.4012 1191.1 31.5237 1190.02 31.5237C1188.94 31.5237 1188.06 32.4012 1188.06 33.4837C1188.06 34.5662 1188.94 35.4437 1190.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1190.02 17.4437C1191.1 17.4437 1191.98 16.5662 1191.98 15.4837C1191.98 14.4012 1191.1 13.5237 1190.02 13.5237C1188.94 13.5237 1188.06 14.4012 1188.06 15.4837C1188.06 16.5662 1188.94 17.4437 1190.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1208.02 71.4537C1209.1 71.4537 1209.98 70.5762 1209.98 69.4937C1209.98 68.4112 1209.1 67.5337 1208.02 67.5337C1206.94 67.5337 1206.06 68.4112 1206.06 69.4937C1206.06 70.5762 1206.94 71.4537 1208.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1208.02 53.4537C1209.1 53.4537 1209.98 52.5762 1209.98 51.4937C1209.98 50.4112 1209.1 49.5337 1208.02 49.5337C1206.94 49.5337 1206.06 50.4112 1206.06 51.4937C1206.06 52.5762 1206.94 53.4537 1208.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1208.02 35.4437C1209.1 35.4437 1209.98 34.5662 1209.98 33.4837C1209.98 32.4012 1209.1 31.5237 1208.02 31.5237C1206.94 31.5237 1206.06 32.4012 1206.06 33.4837C1206.06 34.5662 1206.94 35.4437 1208.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.02 17.4437C1209.1 17.4437 1209.98 16.5662 1209.98 15.4837C1209.98 14.4012 1209.1 13.5237 1208.02 13.5237C1206.94 13.5237 1206.06 14.4012 1206.06 15.4837C1206.06 16.5662 1206.94 17.4437 1208.02 17.4437Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 71.4537C1227.11 71.4537 1227.99 70.5762 1227.99 69.4937C1227.99 68.4112 1227.11 67.5337 1226.03 67.5337C1224.95 67.5337 1224.07 68.4112 1224.07 69.4937C1224.07 70.5762 1224.95 71.4537 1226.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 53.4537C1227.11 53.4537 1227.99 52.5762 1227.99 51.4937C1227.99 50.4112 1227.11 49.5337 1226.03 49.5337C1224.95 49.5337 1224.07 50.4112 1224.07 51.4937C1224.07 52.5762 1224.95 53.4537 1226.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 35.4437C1227.11 35.4437 1227.99 34.5662 1227.99 33.4837C1227.99 32.4012 1227.11 31.5237 1226.03 31.5237C1224.95 31.5237 1224.07 32.4012 1224.07 33.4837C1224.07 34.5662 1224.95 35.4437 1226.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1226.03 17.4437C1227.11 17.4437 1227.99 16.5662 1227.99 15.4837C1227.99 14.4012 1227.11 13.5237 1226.03 13.5237C1224.95 13.5237 1224.07 14.4012 1224.07 15.4837C1224.07 16.5662 1224.95 17.4437 1226.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.03 71.4537C1245.11 71.4537 1245.99 70.5762 1245.99 69.4937C1245.99 68.4112 1245.11 67.5337 1244.03 67.5337C1242.95 67.5337 1242.07 68.4112 1242.07 69.4937C1242.07 70.5762 1242.95 71.4537 1244.03 71.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1244.03 53.4537C1245.11 53.4537 1245.99 52.5762 1245.99 51.4937C1245.99 50.4112 1245.11 49.5337 1244.03 49.5337C1242.95 49.5337 1242.07 50.4112 1242.07 51.4937C1242.07 52.5762 1242.95 53.4537 1244.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1244.03 35.4437C1245.11 35.4437 1245.99 34.5662 1245.99 33.4837C1245.99 32.4012 1245.11 31.5237 1244.03 31.5237C1242.95 31.5237 1242.07 32.4012 1242.07 33.4837C1242.07 34.5662 1242.95 35.4437 1244.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1244.03 17.4437C1245.11 17.4437 1245.99 16.5662 1245.99 15.4837C1245.99 14.4012 1245.11 13.5237 1244.03 13.5237C1242.95 13.5237 1242.07 14.4012 1242.07 15.4837C1242.07 16.5662 1242.95 17.4437 1244.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 71.4537C1263.12 71.4537 1264 70.5762 1264 69.4937C1264 68.4112 1263.12 67.5337 1262.04 67.5337C1260.96 67.5337 1260.08 68.4112 1260.08 69.4937C1260.08 70.5762 1260.96 71.4537 1262.04 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 53.4537C1263.12 53.4537 1264 52.5762 1264 51.4937C1264 50.4112 1263.12 49.5337 1262.04 49.5337C1260.96 49.5337 1260.08 50.4112 1260.08 51.4937C1260.08 52.5762 1260.96 53.4537 1262.04 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 35.4437C1263.12 35.4437 1264 34.5662 1264 33.4837C1264 32.4012 1263.12 31.5237 1262.04 31.5237C1260.96 31.5237 1260.08 32.4012 1260.08 33.4837C1260.08 34.5662 1260.96 35.4437 1262.04 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1262.04 17.4437C1263.12 17.4437 1264 16.5662 1264 15.4837C1264 14.4012 1263.12 13.5237 1262.04 13.5237C1260.96 13.5237 1260.08 14.4012 1260.08 15.4837C1260.08 16.5662 1260.96 17.4437 1262.04 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 71.4537C759.043 71.4537 759.92 70.5762 759.92 69.4937C759.92 68.4112 759.043 67.5337 757.96 67.5337C756.878 67.5337 756 68.4112 756 69.4937C756 70.5762 756.878 71.4537 757.96 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 53.4537C759.043 53.4537 759.92 52.5762 759.92 51.4937C759.92 50.4112 759.043 49.5337 757.96 49.5337C756.878 49.5337 756 50.4112 756 51.4937C756 52.5762 756.878 53.4537 757.96 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 35.4437C759.043 35.4437 759.92 34.5662 759.92 33.4837C759.92 32.4012 759.043 31.5237 757.96 31.5237C756.878 31.5237 756 32.4012 756 33.4837C756 34.5662 756.878 35.4437 757.96 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M757.96 17.4437C759.043 17.4437 759.92 16.5662 759.92 15.4837C759.92 14.4012 759.043 13.5237 757.96 13.5237C756.878 13.5237 756 14.4012 756 15.4837C756 16.5662 756.878 17.4437 757.96 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M775.97 71.4537C777.052 71.4537 777.93 70.5762 777.93 69.4937C777.93 68.4112 777.052 67.5337 775.97 67.5337C774.887 67.5337 774.01 68.4112 774.01 69.4937C774.01 70.5762 774.887 71.4537 775.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.97 53.4537C777.052 53.4537 777.93 52.5762 777.93 51.4937C777.93 50.4112 777.052 49.5337 775.97 49.5337C774.887 49.5337 774.01 50.4112 774.01 51.4937C774.01 52.5762 774.887 53.4537 775.97 53.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M775.97 35.4437C777.052 35.4437 777.93 34.5662 777.93 33.4837C777.93 32.4012 777.052 31.5237 775.97 31.5237C774.887 31.5237 774.01 32.4012 774.01 33.4837C774.01 34.5662 774.887 35.4437 775.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M775.97 17.4437C777.052 17.4437 777.93 16.5662 777.93 15.4837C777.93 14.4012 777.052 13.5237 775.97 13.5237C774.887 13.5237 774.01 14.4012 774.01 15.4837C774.01 16.5662 774.887 17.4437 775.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 71.4537C795.052 71.4537 795.93 70.5762 795.93 69.4937C795.93 68.4112 795.052 67.5337 793.97 67.5337C792.887 67.5337 792.01 68.4112 792.01 69.4937C792.01 70.5762 792.887 71.4537 793.97 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 53.4537C795.052 53.4537 795.93 52.5762 795.93 51.4937C795.93 50.4112 795.052 49.5337 793.97 49.5337C792.887 49.5337 792.01 50.4112 792.01 51.4937C792.01 52.5762 792.887 53.4537 793.97 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 35.4437C795.052 35.4437 795.93 34.5662 795.93 33.4837C795.93 32.4012 795.052 31.5237 793.97 31.5237C792.887 31.5237 792.01 32.4012 792.01 33.4837C792.01 34.5662 792.887 35.4437 793.97 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M793.97 17.4437C795.052 17.4437 795.93 16.5662 795.93 15.4837C795.93 14.4012 795.052 13.5237 793.97 13.5237C792.887 13.5237 792.01 14.4012 792.01 15.4837C792.01 16.5662 792.887 17.4437 793.97 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 71.4537C813.062 71.4537 813.94 70.5762 813.94 69.4937C813.94 68.4112 813.062 67.5337 811.98 67.5337C810.898 67.5337 810.02 68.4112 810.02 69.4937C810.02 70.5762 810.898 71.4537 811.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 53.4537C813.062 53.4537 813.94 52.5762 813.94 51.4937C813.94 50.4112 813.062 49.5337 811.98 49.5337C810.898 49.5337 810.02 50.4112 810.02 51.4937C810.02 52.5762 810.898 53.4537 811.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 35.4437C813.062 35.4437 813.94 34.5662 813.94 33.4837C813.94 32.4012 813.062 31.5237 811.98 31.5237C810.898 31.5237 810.02 32.4012 810.02 33.4837C810.02 34.5662 810.898 35.4437 811.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M811.98 17.4437C813.062 17.4437 813.94 16.5662 813.94 15.4837C813.94 14.4012 813.062 13.5237 811.98 13.5237C810.898 13.5237 810.02 14.4012 810.02 15.4837C810.02 16.5662 810.898 17.4437 811.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 71.4537C831.062 71.4537 831.94 70.5762 831.94 69.4937C831.94 68.4112 831.062 67.5337 829.98 67.5337C828.898 67.5337 828.02 68.4112 828.02 69.4937C828.02 70.5762 828.898 71.4537 829.98 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 53.4537C831.062 53.4537 831.94 52.5762 831.94 51.4937C831.94 50.4112 831.062 49.5337 829.98 49.5337C828.898 49.5337 828.02 50.4112 828.02 51.4937C828.02 52.5762 828.898 53.4537 829.98 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 35.4437C831.062 35.4437 831.94 34.5662 831.94 33.4837C831.94 32.4012 831.062 31.5237 829.98 31.5237C828.898 31.5237 828.02 32.4012 828.02 33.4837C828.02 34.5662 828.898 35.4437 829.98 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M829.98 17.4437C831.062 17.4437 831.94 16.5662 831.94 15.4837C831.94 14.4012 831.062 13.5237 829.98 13.5237C828.898 13.5237 828.02 14.4012 828.02 15.4837C828.02 16.5662 828.898 17.4437 829.98 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 71.4537C849.072 71.4537 849.95 70.5762 849.95 69.4937C849.95 68.4112 849.072 67.5337 847.99 67.5337C846.908 67.5337 846.03 68.4112 846.03 69.4937C846.03 70.5762 846.908 71.4537 847.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 53.4537C849.072 53.4537 849.95 52.5762 849.95 51.4937C849.95 50.4112 849.072 49.5337 847.99 49.5337C846.908 49.5337 846.03 50.4112 846.03 51.4937C846.03 52.5762 846.908 53.4537 847.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 35.4437C849.072 35.4437 849.95 34.5662 849.95 33.4837C849.95 32.4012 849.072 31.5237 847.99 31.5237C846.908 31.5237 846.03 32.4012 846.03 33.4837C846.03 34.5662 846.908 35.4437 847.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M847.99 17.4437C849.072 17.4437 849.95 16.5662 849.95 15.4837C849.95 14.4012 849.072 13.5237 847.99 13.5237C846.908 13.5237 846.03 14.4012 846.03 15.4837C846.03 16.5662 846.908 17.4437 847.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 71.4537C867.072 71.4537 867.95 70.5762 867.95 69.4937C867.95 68.4112 867.072 67.5337 865.99 67.5337C864.908 67.5337 864.03 68.4112 864.03 69.4937C864.03 70.5762 864.908 71.4537 865.99 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 53.4537C867.072 53.4537 867.95 52.5762 867.95 51.4937C867.95 50.4112 867.072 49.5337 865.99 49.5337C864.908 49.5337 864.03 50.4112 864.03 51.4937C864.03 52.5762 864.908 53.4537 865.99 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 35.4437C867.072 35.4437 867.95 34.5662 867.95 33.4837C867.95 32.4012 867.072 31.5237 865.99 31.5237C864.908 31.5237 864.03 32.4012 864.03 33.4837C864.03 34.5662 864.908 35.4437 865.99 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M865.99 17.4437C867.072 17.4437 867.95 16.5662 867.95 15.4837C867.95 14.4012 867.072 13.5237 865.99 13.5237C864.908 13.5237 864.03 14.4012 864.03 15.4837C864.03 16.5662 864.908 17.4437 865.99 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 71.4537C885.082 71.4537 885.96 70.5762 885.96 69.4937C885.96 68.4112 885.082 67.5337 884 67.5337C882.918 67.5337 882.04 68.4112 882.04 69.4937C882.04 70.5762 882.918 71.4537 884 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 53.4537C885.082 53.4537 885.96 52.5762 885.96 51.4937C885.96 50.4112 885.082 49.5337 884 49.5337C882.918 49.5337 882.04 50.4112 882.04 51.4937C882.04 52.5762 882.918 53.4537 884 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 35.4437C885.082 35.4437 885.96 34.5662 885.96 33.4837C885.96 32.4012 885.082 31.5237 884 31.5237C882.918 31.5237 882.04 32.4012 882.04 33.4837C882.04 34.5662 882.918 35.4437 884 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M884 17.4437C885.082 17.4437 885.96 16.5662 885.96 15.4837C885.96 14.4012 885.082 13.5237 884 13.5237C882.918 13.5237 882.04 14.4012 882.04 15.4837C882.04 16.5662 882.918 17.4437 884 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 71.4537C903.092 71.4537 903.97 70.5762 903.97 69.4937C903.97 68.4112 903.092 67.5337 902.01 67.5337C900.928 67.5337 900.05 68.4112 900.05 69.4937C900.05 70.5762 900.928 71.4537 902.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 53.4537C903.092 53.4537 903.97 52.5762 903.97 51.4937C903.97 50.4112 903.092 49.5337 902.01 49.5337C900.928 49.5337 900.05 50.4112 900.05 51.4937C900.05 52.5762 900.928 53.4537 902.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 35.4437C903.092 35.4437 903.97 34.5662 903.97 33.4837C903.97 32.4012 903.092 31.5237 902.01 31.5237C900.928 31.5237 900.05 32.4012 900.05 33.4837C900.05 34.5662 900.928 35.4437 902.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M902.01 17.4437C903.092 17.4437 903.97 16.5662 903.97 15.4837C903.97 14.4012 903.092 13.5237 902.01 13.5237C900.928 13.5237 900.05 14.4012 900.05 15.4837C900.05 16.5662 900.928 17.4437 902.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 71.4537C921.092 71.4537 921.97 70.5762 921.97 69.4937C921.97 68.4112 921.092 67.5337 920.01 67.5337C918.928 67.5337 918.05 68.4112 918.05 69.4937C918.05 70.5762 918.928 71.4537 920.01 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 53.4537C921.092 53.4537 921.97 52.5762 921.97 51.4937C921.97 50.4112 921.092 49.5337 920.01 49.5337C918.928 49.5337 918.05 50.4112 918.05 51.4937C918.05 52.5762 918.928 53.4537 920.01 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 35.4437C921.092 35.4437 921.97 34.5662 921.97 33.4837C921.97 32.4012 921.092 31.5237 920.01 31.5237C918.928 31.5237 918.05 32.4012 918.05 33.4837C918.05 34.5662 918.928 35.4437 920.01 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M920.01 17.4437C921.092 17.4437 921.97 16.5662 921.97 15.4837C921.97 14.4012 921.092 13.5237 920.01 13.5237C918.928 13.5237 918.05 14.4012 918.05 15.4837C918.05 16.5662 918.928 17.4437 920.01 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 71.4537C939.102 71.4537 939.98 70.5762 939.98 69.4937C939.98 68.4112 939.102 67.5337 938.02 67.5337C936.938 67.5337 936.06 68.4112 936.06 69.4937C936.06 70.5762 936.938 71.4537 938.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 53.4537C939.102 53.4537 939.98 52.5762 939.98 51.4937C939.98 50.4112 939.102 49.5337 938.02 49.5337C936.938 49.5337 936.06 50.4112 936.06 51.4937C936.06 52.5762 936.938 53.4537 938.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 35.4437C939.102 35.4437 939.98 34.5662 939.98 33.4837C939.98 32.4012 939.102 31.5237 938.02 31.5237C936.938 31.5237 936.06 32.4012 936.06 33.4837C936.06 34.5662 936.938 35.4437 938.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M938.02 17.4437C939.102 17.4437 939.98 16.5662 939.98 15.4837C939.98 14.4012 939.102 13.5237 938.02 13.5237C936.938 13.5237 936.06 14.4012 936.06 15.4837C936.06 16.5662 936.938 17.4437 938.02 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M956.02 71.4537C957.102 71.4537 957.98 70.5762 957.98 69.4937C957.98 68.4112 957.102 67.5337 956.02 67.5337C954.938 67.5337 954.06 68.4112 954.06 69.4937C954.06 70.5762 954.938 71.4537 956.02 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M956.02 53.4537C957.102 53.4537 957.98 52.5762 957.98 51.4937C957.98 50.4112 957.102 49.5337 956.02 49.5337C954.938 49.5337 954.06 50.4112 954.06 51.4937C954.06 52.5762 954.938 53.4537 956.02 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M956.02 35.4437C957.102 35.4437 957.98 34.5662 957.98 33.4837C957.98 32.4012 957.102 31.5237 956.02 31.5237C954.938 31.5237 954.06 32.4012 954.06 33.4837C954.06 34.5662 954.938 35.4437 956.02 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.02 17.4437C957.102 17.4437 957.98 16.5662 957.98 15.4837C957.98 14.4012 957.102 13.5237 956.02 13.5237C954.938 13.5237 954.06 14.4012 954.06 15.4837C954.06 16.5662 954.938 17.4437 956.02 17.4437Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 71.4537C975.113 71.4537 975.99 70.5762 975.99 69.4937C975.99 68.4112 975.113 67.5337 974.03 67.5337C972.948 67.5337 972.07 68.4112 972.07 69.4937C972.07 70.5762 972.948 71.4537 974.03 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 53.4537C975.113 53.4537 975.99 52.5762 975.99 51.4937C975.99 50.4112 975.113 49.5337 974.03 49.5337C972.948 49.5337 972.07 50.4112 972.07 51.4937C972.07 52.5762 972.948 53.4537 974.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 35.4437C975.113 35.4437 975.99 34.5662 975.99 33.4837C975.99 32.4012 975.113 31.5237 974.03 31.5237C972.948 31.5237 972.07 32.4012 972.07 33.4837C972.07 34.5662 972.948 35.4437 974.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M974.03 17.4437C975.113 17.4437 975.99 16.5662 975.99 15.4837C975.99 14.4012 975.113 13.5237 974.03 13.5237C972.948 13.5237 972.07 14.4012 972.07 15.4837C972.07 16.5662 972.948 17.4437 974.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.03 71.4537C993.113 71.4537 993.99 70.5762 993.99 69.4937C993.99 68.4112 993.113 67.5337 992.03 67.5337C990.948 67.5337 990.07 68.4112 990.07 69.4937C990.07 70.5762 990.948 71.4537 992.03 71.4537Z",
    fill: "#FF3E6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M992.03 53.4537C993.113 53.4537 993.99 52.5762 993.99 51.4937C993.99 50.4112 993.113 49.5337 992.03 49.5337C990.948 49.5337 990.07 50.4112 990.07 51.4937C990.07 52.5762 990.948 53.4537 992.03 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M992.03 35.4437C993.113 35.4437 993.99 34.5662 993.99 33.4837C993.99 32.4012 993.113 31.5237 992.03 31.5237C990.948 31.5237 990.07 32.4012 990.07 33.4837C990.07 34.5662 990.948 35.4437 992.03 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M992.03 17.4437C993.113 17.4437 993.99 16.5662 993.99 15.4837C993.99 14.4012 993.113 13.5237 992.03 13.5237C990.948 13.5237 990.07 14.4012 990.07 15.4837C990.07 16.5662 990.948 17.4437 992.03 17.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 71.4537C1011.12 71.4537 1012 70.5762 1012 69.4937C1012 68.4112 1011.12 67.5337 1010.04 67.5337C1008.96 67.5337 1008.08 68.4112 1008.08 69.4937C1008.08 70.5762 1008.96 71.4537 1010.04 71.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 53.4537C1011.12 53.4537 1012 52.5762 1012 51.4937C1012 50.4112 1011.12 49.5337 1010.04 49.5337C1008.96 49.5337 1008.08 50.4112 1008.08 51.4937C1008.08 52.5762 1008.96 53.4537 1010.04 53.4537Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 35.4437C1011.12 35.4437 1012 34.5662 1012 33.4837C1012 32.4012 1011.12 31.5237 1010.04 31.5237C1008.96 31.5237 1008.08 32.4012 1008.08 33.4837C1008.08 34.5662 1008.96 35.4437 1010.04 35.4437Z",
    fill: "#050912"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M1010.04 17.4437C1011.12 17.4437 1012 16.5662 1012 15.4837C1012 14.4012 1011.12 13.5237 1010.04 13.5237C1008.96 13.5237 1008.08 14.4012 1008.08 15.4837C1008.08 16.5662 1008.96 17.4437 1010.04 17.4437Z",
    fill: "#050912"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1320,
    height: 75,
    fill: "white",
    transform: "translate(0 0.513672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_3583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1516,
    height: 256,
    fill: "white",
    transform: "translate(0 -4.48633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots1);
export default __webpack_public_path__ + "static/media/dots-1.71e588c3b9fa2be11aadad078b02ac4a.svg";
export { ForwardRef as ReactComponent };